import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'lodash'
import API from '@/api/home.js'
import i18n from '@/i18n'
import router from './router'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  plugins: [
    createPersistedState({
      key: 'owlOBS',
      reducer (state) {
        return {
          lang: state.lang,
          token: state.token,
          user: state.user
        }
      }
    })
  ],
  state: {
    lang: 'en',
    routerNames: [],
    industries: [],
    features: [],
    news: [],
    solutions: [],
    partners: [],
    isContactForm: false,
    formSelected: null,
    token: null,
    user: null,
    hasAgreeCookie: false
  },
  getters: {
    token: (state) => state.token,
    user: (state) => state.user,
    lang: (state) => state.lang,
    routerNames: (state) => state.routerNames,
    industries: (state) => _.chain(state.industries).orderBy(['active', 'sort'], ['desc']).value(),
    activeIndustries: (state) => {
      return _.filter(state.industries, { active: true, hide: false })
    },
    plans: (state) => state.plans,
    IOTs: (state) => state.IOTs,
    industry: function (state) {
      if (state.route.params.industry && !_.isEmpty(state.routerNames)) {
        const industryId = _.find(state.routerNames, router => router.name === state.route.params.industry).industry.id
        return _.find(state.industries, industry => industry.id === industryId)
      } else if (!_.isEmpty(state.routerNames)) {
        const industryId = _.find(state.routerNames, router => _.snakeCase(router.name) === _.snakeCase(state.route.name)).industry.id
        return _.find(state.industries, industry => industry.id === industryId)
      }
      return false
    },
    features: (state) => state.features,
    news: function (state) {
      return type => state.news.filter(news => {
        return news.type === type
      })
    },
    solutions: (state) => state.solutions,
    partners: (state) => {
      return _.chain(state.partners).orderBy(['weights'], ['desc']).value()
    },
    isContactForm: (state) => state.isContactForm,
    hasAgreeCookie: (state) => state.hasAgreeCookie,
    formSelected: (state) => state.formSelected
  },
  mutations: {
    ROUTER_NAMES (state, payload) {
      state.routerNames = payload
    },
    INDUSTRIES (state, payload) {
      state.industries = payload
    },
    FEATURES (state, payload) {
      state.features = payload
    },
    NEWS (state, payload) {
      state.news = payload
    },
    SOLUTIONS (state, payload) {
      state.solutions = payload
    },
    PARTNERS (state, payload) {
      state.partners = payload
    },
    SET_IS_CONTACT_FORM (state, payload) {
      state.isContactForm = payload
    },
    SET_FORM_SELECTED (state, payload) {
      state.formSelected = payload
    },
    SET_LANG (state, payload) {
      i18n.locale = payload
      state.lang = payload
    },
    SET_TOKEN (state, payload) {
      state.token = payload
    },
    SET_USER (state, payload) {
      state.user = payload
    },
    CLEAR_USER (state) {
      state.token = null
      state.user = null
    },
    SET_COOKIE (state) {
      state.hasAgreeCookie = true
    }
  },
  actions: {
    userLogin: function ({ commit }, payload) {
      const {
        jwt,
        user
      } = payload
      commit('SET_TOKEN', jwt)
      commit('SET_USER', user)
    },
    userLogout: function ({ commit }) {
      commit('CLEAR_USER')
      router.replace({
        name: 'login'
      })
    },
    fetchRouterNames: function ({ commit }) {
      return API.routerNames().then(res => {
        commit('ROUTER_NAMES', res.data)
      })
    },
    fetchIndustries: function ({ commit }) {
      return API.industries().then(res => {
        commit('INDUSTRIES', res.data)
      })
    },
    fetchFeatures: function ({ commit }) {
      return API.features().then(res => {
        commit('FEATURES', res.data)
      })
    },
    fetchNews: function ({ commit }) {
      return API.news().then(res => {
        commit('NEWS', res.data)
      })
    },
    fetchSolutions: function ({ commit }) {
      return API.solutions().then(res => {
        commit('SOLUTIONS', res.data)
      })
    },
    fetchPartners: function ({ commit }) {
      return API.partners().then(res => {
        commit('PARTNERS', res.data)
      })
    },
    openContactForm: function ({ commit }, payload) {
      if (payload) {
        commit('SET_FORM_SELECTED', payload)
      }
      commit('SET_IS_CONTACT_FORM', true)
    },
    cancelContactForm: function ({ commit }) {
      commit('SET_IS_CONTACT_FORM', false)
    },
    setLanguage: function ({ commit }, lang) {
      commit('SET_LANG', lang)
    },
    submitContactForm: function ({ commit }, payload) {
      let data = {
        office_name: payload.office,
        industry: `${payload.industry.routername.name} - ${payload.industry.name}`,
        contact_name: payload.name,
        contact_phone: payload.tel,
        contact_email: payload.email,
        requirement: payload.description,
        type: 'OBS_free_trial'
      }
      // if (payload.industry.name === '農業生產') {
      //   data = {
      //     ...data,
      //     plan: payload.plan
      //   }
      // }
      return API.postContactForm(data).then(res => {
        if (res.status === 200) {
          commit('SET_IS_CONTACT_FORM', false)
        }
        return res
      })
    }
  }
})
